//css-------------------
import "@/css/home/index.scss";
import "@/css/share/components/_article_link.scss";
import "@/css/share/components/_course_card.scss";

//components-------------------
import { init_imageloaded, navActiveMixin, searchMixin, menuMixin, winW, winH } from "@/js/share/mixins/componentsMixin.js";

//npm lib
import $ from "jquery";
import { createApp } from "vue";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const NEWS_TABS = JSON.parse(document.getElementById("news-tabs")?.textContent || "[]");
const NEWS_DATA = JSON.parse(document.getElementById("news-data")?.textContent || "[]");
const NEWS_PREVIEW_SIZE = 5;

const app = createApp({
    mixins: [navActiveMixin, searchMixin, menuMixin, init_imageloaded],
    data() {
        return {
            // hero carousel
            slideCount: 3,
            currentSlide: 0,
            heroTimer: null,
            heroInterval: 6500,
            // news tabs
            news: NEWS_DATA,
            currentTab: 0,
            newsTabs: NEWS_TABS,
            // video lightbox
            videoModal: { open: false, id: null },
        };
    },
    computed: {
        videoEmbedSrc() {
            return this.videoModal.id
                ? `https://www.youtube.com/embed/${this.videoModal.id}?autoplay=1&rel=0&modestbranding=1`
                : "";
        },
        newsTabsWithCount() {
            return this.newsTabs.map((tab, idx) => ({
                ...tab,
                count: idx === 0
                    ? this.news.length
                    : this.news.filter(n => n.tag === tab.name).length,
            }));
        },
        filteredNews() {
            const tab = this.newsTabs[this.currentTab];
            const list = this.currentTab === 0
                ? this.news
                : this.news.filter(n => n.tag === tab.name);
            return list.slice(0, NEWS_PREVIEW_SIZE);
        },
    },
    mounted() {
        this.startHeroTimer();
        this.onKeydown = (e) => {
            if (e.key === "Escape" && this.videoModal.open) this.closeVideo();
        };
        window.addEventListener("keydown", this.onKeydown);
        init_imageloaded(() => {
            // 進場動畫

        })
    },
    beforeUnmount() {
        this.stopHeroTimer();
        window.removeEventListener("keydown", this.onKeydown);
    },
    methods: {
        openVideo(id) {
            this.videoModal.id = id;
            this.videoModal.open = true;
            document.body.classList.add("is_video_open");
        },
        closeVideo() {
            this.videoModal.open = false;
            this.videoModal.id = null;
            document.body.classList.remove("is_video_open");
        },
        goSlide(i) {
            this.currentSlide = (i + this.slideCount) % this.slideCount;
            this.resetHeroTimer();
        },
        nextSlide() {
            this.goSlide(this.currentSlide + 1);
        },
        prevSlide() {
            this.goSlide(this.currentSlide - 1);
        },
        startHeroTimer() {
            this.stopHeroTimer();
            this.heroTimer = setInterval(() => {
                this.currentSlide = (this.currentSlide + 1) % this.slideCount;
            }, this.heroInterval);
        },
        stopHeroTimer() {
            if (this.heroTimer) {
                clearInterval(this.heroTimer);
                this.heroTimer = null;
            }
        },
        resetHeroTimer() {
            this.startHeroTimer();
        },
    },
})
app.mount("#app");
